import { Table } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { SensorLog } from "src/services/core/log/models/Log";

type Props = { log: SensorLog };

const LogRow = ({ log }: Props) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "inApp.logs.sensor",
  });

  return (
    <Table.Tr>
      <Table.Td>{log.time.toLocaleTimeString()}</Table.Td>
      <Table.Td>{log.deviceName}</Table.Td>
      <Table.Td>{t("status." + log.status.toString())}</Table.Td>
    </Table.Tr>
  );
};

export default LogRow;
